<template>
  <div class="companyAuthInfo">
    <div class="account-user">
      <el-breadcrumb separator="/" class="bc-nav">
        <el-breadcrumb-item :to="{ path: '/companyInfo' }">企业资料</el-breadcrumb-item>
        <el-breadcrumb-item>企业认证</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="tips-con" id="auto-0" v-if="!certificateInfo.cancelUpdateFlag">
      <template v-if="certificateInfo.certificateStatus === 5 || certificateInfo.certificateStatus === 6">
        <span @click="handleToUpdateInfo" class="pointer"> {{ certificateInfo.certificateStatusResult }}></span>
      </template>
      <template v-else>
        {{ certificateInfo.certificateStatusResult }}
      </template>
    </div>
    <div class="segment-outer">
      <div class="segment statistics">
        <div class="segment-header">营业执照</div>
        <div class="segment-area segment-item-box">
          <div class="segment-item">
            <span class="name">营业执照：</span>
            <div
              class="pic-preview"
              id="auto-1"
              :style="{
                backgroundImage: 'url(' + urlPrefix + businessLicenseResponse.photoUploadUrl + ')'
              }"
              @click="showViewer($event, 'photoUploadViewer')"
            >
              <img :src="urlPrefix + businessLicenseResponse.photoUploadUrl" style="display: none" />
            </div>
          </div>
          <div class="segment-item">
            <span class="name">企业名称：</span>
            <span class="dec" id="auto-3">{{ businessLicenseResponse.companyName }}</span>
          </div>
          <div class="segment-item">
            <span class="name">统一社会信用代码：</span>
            <span class="dec" id="auto-2">{{ businessLicenseResponse.creditCode }}</span>
          </div>
          <div class="segment-item">
            <span class="name">注册地址：</span>
            <span class="dec" id="auto-4">{{ businessLicenseResponse.registerAddress }}</span>
          </div>
          <div class="segment-item">
            <span class="name">法定代表人姓名：</span>
            <span class="dec" id="auto-5">{{ businessLicenseResponse.corpName }}</span>
          </div>
          <div class="segment-item">
            <span class="name">营业期限开始日期：</span>
            <span class="dec" id="auto-6" v-if="businessLicenseResponse.startDate">{{
              businessLicenseResponse.startDate | stamp2TextDate
            }}</span>
            <span class="dec" v-else>无</span>
          </div>
          <div class="segment-item">
            <span class="name">营业期限结束日期：</span>
            <span class="dec" id="auto-7" v-if="businessLicenseResponse.longTermFlag">长期有效</span>
            <template v-else>
              <span v-if="businessLicenseResponse.endDate">
                {{ businessLicenseResponse.endDate | stamp2TextDate }}</span
              >
              <span v-else>无</span>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="segment-outer">
      <div class="segment statistics">
        <div class="segment-header">法人</div>
        <div class="segment-area segment-item-box">
          <div class="segment-item">
            <span class="name">身份证照片：</span>
            <div id="auto-8">
              <img
                class="mr-10"
                v-if="urlPrefix + corpResponse.idCardFrontImageUrl"
                :src="idcardfrontPic"
                alt=""
                width="192"
                height="120"
              />
              <img
                class="mr-10"
                v-if="urlPrefix + corpResponse.idCardBackImageUrl"
                :src="idcardBackPic"
                alt=""
                width="192"
                height="120"
              />
            </div>
          </div>
          <div class="segment-item">
            <span class="name">法定代表人：</span>
            <span class="dec" id="auto-9">{{ corpResponse.corpName }}</span>
          </div>
          <div class="segment-item">
            <span class="name">法定代表人身份证号：</span>
            <span class="dec" id="auto-10">{{ corpResponse.identityCard | filterIdcard(1, 1) }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="segment-outer" v-if="certificateInfo.otherPhotoUploadUrl">
      <div class="segment statistics">
        <div class="segment-header">其他资料</div>
        <div class="segment-area segment-item-box">
          <div class="segment-item">
            <span class="name">其他资料：</span>
            <div
              class="pic-preview"
              id="auto-11"
              :style="{
                backgroundImage: 'url(' + urlPrefix + certificateInfo.otherPhotoUploadUrl + ')'
              }"
              @click="showViewer($event, 'otherPhotoViewer')"
            >
              <img :src="urlPrefix + certificateInfo.otherPhotoUploadUrl" style="display: none" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-bottom">
      <!-- 加上管理员实名认证的判断-->
      <el-button type="primary" v-if="certificateStatus === 2" @click="handleEdit" id="auto-12">修改企业信息</el-button>
      <el-button
        type="primary"
        id="auto-13"
        v-if="certificateStatus == 3 || (certificateStatus == 6 && certificateInfo.cancelUpdateFlag)"
        @click="handleEdit"
        >变更企业信息</el-button
      >
    </div>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:13
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axiosNew from '@/api/axiosNew';
import newApi from '@/api/settings.new.api';
import idcardBackPic from '@/assets/img/pic_idcard_bm.png';
import idcardfrontPic from '@/assets/img/pic_idcard_zm.png';
import 'viewerjs/dist/viewer.css';
import Viewer from 'viewerjs';
import { getFileUrlPrefix } from '@/utils';
export default {
  data() {
    return {
      urlPrefix: '',
      identityCard: '',
      idcardBackPic: idcardBackPic,
      idcardfrontPic: idcardfrontPic,
      certificateStatus: 0, // 认证状态 0未认证 1审核中 2审核未通过 3已认证 4待更新 5更新审核中 6更新申请未通过
      faceCertificateStatus: false, // 管理员实名认证状态
      certificateInfo: {}, // 所有认证信息
      businessLicenseResponse: {}, // 营业执照信息
      corpResponse: {}, // 法人信息
      photoUploadViewer: '',
      otherPhotoViewer: ''
    };
  },
  async created() {
    this.urlPrefix = await getFileUrlPrefix();
    this.fetchData();
  },
  methods: {
    fetchData() {
      axiosNew.post(newApi.qryCerEnterpriseinfo).then(res => {
        this.certificateStatus = res.data.certificateStatus;
        this.faceCertificateStatus = res.data.faceCertificateStatus;
        this.certificateInfo = res.data;
        this.businessLicenseResponse = res.data.businessLicenseResponse || {};
        this.corpResponse = res.data.corpResponse;
      });
    },
    handleEdit() {
      if (this.certificateStatus !== 0) {
        this.$router.push({ path: '/companyAuthEdit' });
      }
    },
    handleToUpdateInfo() {
      this.$router.push({ path: '/companyInfoUpdate' });
    },
    showViewer(event, type) {
      if (!this[type]) {
        this[type] = new Viewer(event.target, {});
      }
      this[type].show();
    }
  }
};
</script>

<style scoped>
.segment-item-box {
  margin: 40px 20px;
}
.segment-item {
  display: flex;
  margin: 20px 0;
}
.segment-item .name {
  width: 164px;
  color: #90a0b1;
}
.segment-item .name.short {
  width: 100px;
}
.download {
  display: inline-block;
  margin-bottom: 10px;
}
.segment-item .dec {
  color: #424b53;
}
.pic-preview {
  width: 192px;
  height: 120px;
  background-size: 100% 100%;
}
.pic-preview img {
  width: 100%;
  height: 100%;
}
.btn-group {
  padding: 30px 10px 0 40px;
  border-top: 1px solid #e8ecef;
}
.submit-btn {
  border: 1px solid #1cc466;
  color: #1cc466;
}
.idcard {
  display: flex;
}
.btn-bottom {
  margin: 40px;
}
</style>
<style>
.companyAuthInfo .self-brefore .el-input__inner {
  width: 386px;
}
.companyAuthInfo .el-form-item__label {
  color: #90a0b1;
}
</style>
